export * from "./BridgeWorkflowConfiguration";
export * from "./VeneerWorkflowConfiguration";
export * from "./LayWorkflowConfiguration";
export * from "./InlayCoreWorkflowConfiguration";
export * from "./WaxBiteWorkflowConfiguration";
export * from "./RetentionWireWorkflowConfiguration";
export * from "./types";
export * from "./DentureRepairWorkflowConfiguration";

import { BridgeWorkflowConfiguration } from "./BridgeWorkflowConfiguration";
import { VeneerWorkflowConfiguration } from "./VeneerWorkflowConfiguration";
import { LayWorkflowConfiguration } from "./LayWorkflowConfiguration";
import { CrownWorkflowConfiguration } from "./CrownWorkflowConfiguration";
import { SplintedCrownWorkflowConfiguration } from "./SplintedCrownWorkflowConfiguration";
import { InlayCoreWorkflowConfiguration } from "./InlayCoreWorkflowConfiguration";
import { WaxBiteWorkflowConfiguration } from "./WaxBiteWorkflowConfiguration";
import { SpaceMaintainerWorkflowConfiguration } from "./SpaceMaintainerWorkflowConfiguration";
import { RetentionWireWorkflowConfiguration } from "./RetentionWireWorkflowConfiguration";
import { WaxUpWorkflowConfiguration } from "./WaxUpWorkflowConfiguration";
import { CustomTrayWorkflowConfiguration } from "./CustomTrayWorkflowConfiguration";
import { OrthoModelWorkflowConfiguration } from "./OrthoModelWorkflowConfiguration";
import { DentureRepairWorkflowConfiguration } from "./DentureRepairWorkflowConfiguration";
import { AdditionalImpressionForRemovableProsthesisWorkflowConfiguration } from "./AdditionalImpressionForRemovableProsthesisWorkflowConfiguration";
import { AddingTeethOnExistingDentureWorkflowConfiguration } from "./AddingTeethOnExistingDentureWofklowConfiguration";
import { ImplantCrownWorkflowConfiguration } from "./ImplantCrownWorkflowConfiguration";
import { ImplantSplintedCrownWorkflowConfiguration } from "./ImplantSplintedCrownWorkflowConfiguration";
import { ImplantBridgeWorkflowConfiguration } from "./ImplantBridgeWorkflowConfiguration";

export const productWorkflowConfigurations = {
  [BridgeWorkflowConfiguration.productType]: BridgeWorkflowConfiguration,
  [VeneerWorkflowConfiguration.productType]: VeneerWorkflowConfiguration,
  [LayWorkflowConfiguration.productType]: LayWorkflowConfiguration,
  [CrownWorkflowConfiguration.productType]: CrownWorkflowConfiguration,
  [SplintedCrownWorkflowConfiguration.productType]:
    SplintedCrownWorkflowConfiguration,
  [InlayCoreWorkflowConfiguration.productType]: InlayCoreWorkflowConfiguration,
  [WaxBiteWorkflowConfiguration.productType]: WaxBiteWorkflowConfiguration,
  [SpaceMaintainerWorkflowConfiguration.productType]:
    SpaceMaintainerWorkflowConfiguration,
  [RetentionWireWorkflowConfiguration.productType]:
    RetentionWireWorkflowConfiguration,
  [WaxUpWorkflowConfiguration.productType]: WaxUpWorkflowConfiguration,
  [CustomTrayWorkflowConfiguration.productType]:
    CustomTrayWorkflowConfiguration,
  [OrthoModelWorkflowConfiguration.productType]:
    OrthoModelWorkflowConfiguration,
  [DentureRepairWorkflowConfiguration.productType]:
    DentureRepairWorkflowConfiguration,
  [AdditionalImpressionForRemovableProsthesisWorkflowConfiguration.productType]:
    AdditionalImpressionForRemovableProsthesisWorkflowConfiguration,
  [AddingTeethOnExistingDentureWorkflowConfiguration.productType]:
    AddingTeethOnExistingDentureWorkflowConfiguration,
  [ImplantCrownWorkflowConfiguration.productType]:
    ImplantCrownWorkflowConfiguration,
  [ImplantSplintedCrownWorkflowConfiguration.productType]:
    ImplantSplintedCrownWorkflowConfiguration,
  [ImplantBridgeWorkflowConfiguration.productType]:
    ImplantBridgeWorkflowConfiguration,
} as const;
